import type { FC } from 'react';
import { Check } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Badge } from '@/components/ui/badge';

export const FormCompletedBadge: FC = () => {
  const { t } = useTranslation(['component']);

  return (
    <Badge className="border-transparent bg-emerald-600 font-semibold text-neutral-50">
      <Check aria-hidden />
      {t('component:badge.formCompleted')}
    </Badge>
  );
};
